import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const HomeMissionVissionSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */
    const [section, setSection] = useState({
        mission_content: "",
        vission_content: "",
    });


    const [image, setImage] = useState(null);
    const [imagePreview, setimagePreview] = useState("");


    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/home_page/get_home_page_mv_content/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const mvContent  = res.data.data.section;
                setSection({
                    mission_content: mvContent?.mission_content || "",
                    vission_content: mvContent?.vission_content || "",
                });

                if (mvContent?.mv_image) {
                    setimagePreview(
                        `${baseAPIUrl}assets/images/home-page/${mvContent.mv_image}`
                    );
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- INPUT HANDLERS ---------------- */
    const handleSectionChange = (e) => {
        setSection({ ...section, [e.target.name]: e.target.value });
    };

    /* ---------------- SUBMIT ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(section));

            if (image) {
                formData.append("mv_image", image);
            }

            const res = await axios.post(
                `${baseAPIUrl}admin/home_page/add_edit_home_page_mv`,
                formData,
                { withCredentials: true }
            );

            fetchContent();
            scrollToTop();
            setMessage(res.data.msg);
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveImage = async () => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this image? This action cannot be undone."
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            const res = await axios.post(
                `${baseAPIUrl}admin/home_page/delete_home_mission_vission_image`,
                formData ,
                { withCredentials: true }
            );

            if (res.data.status === 1) {
                setimagePreview("");
                setImage(null);
                fetchContent();
                scrollToTop();
                setMessage(res.data.msg);
            } else {
                scrollToTop();
                setMessage(res.data.msg || "Failed to delete image");
            }
        } catch (err) {
            console.error(err);
            scrollToTop();
            setMessage("Failed to delete image.");
        } finally {
            setLoading(false);
            scrollToTop();
        }
    }; 


    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">
                                Home mission-vission section
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    Home page
                                </li>
                                <li className="breadcrumb-item active">
                                    Home mission-vission section
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h4>Edit Home mission vission section</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                {message && (
                                    <p className="text-center text-danger">{message}</p>
                                )}

                                {/* Section Fields */}
                                {/* Mission content*/}
                                <div className="form-group">
                                    <label className="mt-3">Mission content (one point per line)</label>
                                    <textarea
                                        name="mission_content"
                                        rows="5"
                                        className="form-control"
                                        value={section.mission_content}
                                        placeholder={`• Quality education\n• Holistic development\n• Value-based learning`}
                                        onChange={handleSectionChange}
                                    />
                                    <small className="text-muted">
                                        Enter one bullet point per line
                                    </small>
                                </div>

                                {/* Vission content */}
                                <div className="form-group">
                                    <label className="mt-3">Vission content (one point per line)</label>
                                    <textarea
                                        name="vission_content"
                                        rows="5"
                                        className="form-control"
                                        value={section.vission_content}
                                        placeholder={`• Quality education\n• Holistic development\n• Value-based learning`}
                                        onChange={handleSectionChange}
                                    />
                                    <small className="text-muted">
                                        Enter one bullet point per line
                                    </small>
                                </div>

                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>About section image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setImage(file);
                                                setimagePreview(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                    {imagePreview && (
                                        <div style={{ marginTop: "10px" }}>
                                            <img
                                                src={imagePreview}
                                                alt="Mission Vission section image Preview"
                                                style={{ maxWidth: "120px", display: "block", marginBottom: "8px" }}
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={handleRemoveImage}
                                            >
                                                Remove Image
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>

                            <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeMissionVissionSection;
